<template>
  <v-container fluid>
   

        <!-- <v-autocomplete
            v-model="domain"
            :items="domains"
            outlined
            dense
            item-text="domain"
            item-value="domain"
            chips
            small-chips
            label="Domain"
            @change="getPostTypes(domain)"
            
          ></v-autocomplete>
        -->
        
          <v-text-field v-model="title" label="Post Title"></v-text-field>
        <vue-editor v-model="content" />

      

             <!-- <v-btn color="primary" @click="post(contentId,domain,type,title)" class="mt-2">Publish</v-btn> -->
            <v-btn color="primary" @click="save(contentId,domain,type,title,true)" class="mt-2 ml-2">Save</v-btn>
            <v-switch
                v-model="autoSave"
                label= "Auto Save"
            ></v-switch>

  <v-snackbar
      v-model="snackbar"
      :timeout="360"
      :value="true"
      color="blue"
      absolute
      center
      rounded="pill"
      top
    >
    {{ snackbarMsg }}
  </v-snackbar>

  </v-container>
</template>

<style>
canvas {
  width: 100% !important;
  height: 600px !important;
}

tbody tr:nth-child(odd) {
  background-color: rgba(0, 0, 0, 0.05);
}

</style>

<script>
//USE TIPTAP AS Text editor
import { VueEditor } from "vue2-editor";

export default {
   components: { VueEditor },

  data: function() {
    return {
      domains: [],
      type: "",
      title: "",
      from_language: "",
      to_language: "",
      types: [],
      src_lang: [],
      to_lang: [],
      domain: "",
      tableLoading: true,
      translate: false,
      search: "",
      snackbar: false,
      snackbarMsg: "",
      content: "",
      contentId: "",
      autoSave: false,
      refreshId: "",
      headers: [
        {
          text: "Domain",
          sortable: true,
          value: "domain",
        },     
        { text: "Type", value: "type" },
  
         { text: "Login", value: "login_url" },
  
      ],
    
    };
  },
  watch: {
    autoSave(){
            if(this.autoSave){
                  var self = this
                  this.refreshId = setInterval(function(){     
                      if(self.domain != ""){
                        console.log("Automatically Saved!")
                        self.save(self.contentId,self.domain,self.type,self.title)
                      }
            
                      }, 10000);
              }else{
                    clearInterval(this.refreshId);

              }
    } 
  },
  created: function() {
    this.contentId = this.$route.query.contentId
    this.autoSave = true

    if(typeof this.contentId != "undefined"){
        this.$store
        .dispatch("getPostData", {contentId: this.contentId})
        .then(async (response) => {

          this.content = response.data.content
          this.title = response.data.title
          this.domain = response.data.domain.domain
          this.$store
                    .dispatch("getPostTypes", {domain: this.domain})
                    .then(async (response2) => {
                        this.types = response2.data
                        this.type = response.data.post_type

            })
        })
    } 
    this.$store
      .dispatch("getDomains")
      .then(async (response) => {
          this.domains = response.data
      })

     this.$store
      .dispatch("getLanguages")
      .then(async (response) => {
            this.src_lang = response.data.src_lang
            this.to_lang = response.data.to_lang
      })

 
    },
    methods: {
     
         post (contentId,domain,type,title){
                var content = this.content
                this.$store
                    .dispatch("postContent", {contentId: contentId, domain: domain, content: content,  title: title, type: type, translate: this.translate, src_language: this.from_language, to_language: this.to_language })
                    .then(async (response) => {
                        
                      this.snackbarMsg = response.data
                      this.snackbar = true

                    }).catch( (e) => {
                      console.log(e.response.data)
                      this.snackbarMsg = e.response.data
                      this.snackbar = true
                    })
        },
        getPostTypes(domain){
                 this.$store
                    .dispatch("getPostTypes", {domain: domain})
                    .then(async (response) => {
                        this.types = response.data
                    })
        },
        save (contentId,domain,type,title,showSnackbar = false){
                
                var content = this.content
                this.$store
                    .dispatch("saveContent", {contentId: contentId, domain: domain, content: content,  title: title, type: type, translate: this.translate, src_language: this.from_language, to_language: this.to_language })
                    .then(async (response) => {
                      
                      this.snackbarMsg = response.data.msg
                      if(showSnackbar)
                        this.snackbar = true

                      this.content = response.data.content
                      this.title = response.data.post_title

                      if(this.contentId == undefined || typeof this.contentId == "undefined"){
                        this.contentId = response.data.contentId
                      }
                      // this.content = ""
                      // this.title = "" 
                    }).catch( (e) => {
                      console.log(e.response.data)
                      this.snackbarMsg = e.response.data
                      this.snackbar = true
                    })   
        },
        translateFunction (contentId,domain,type,title,){
                
                var content = this.content
                this.$store
                    .dispatch("translateContent", {content: content,  title: title, translate: this.translate, src_language: this.from_language, to_language: this.to_language })
                    .then(async (response) => {
                      this.content = response.data.content
                      this.title = response.data.post_title

                      this.snackbarMsg = response.data.msg
                      this.snackbar = true

                   
                  
              
                    }).catch( (e) => {
                      console.log(e.response.data)
                      this.snackbarMsg = e.response.data
                      this.snackbar = true
                    })   
        },

    },
     destroyed(){
        clearInterval(this.refreshId);

    } 


  }

</script>
